/**
 * SlotsRemainingBadge — Indicador de vagas restantes com 3 níveis de urgência
 */
import { h } from 'preact';
import { T } from '../../styles/tokens';

export interface SlotsRemainingBadgeProps {
  max: number;
  current: number;
  textColor?: string;
}

export function SlotsRemainingBadge({ max, current, textColor }: SlotsRemainingBadgeProps) {
  if (!max || max <= 0) return null;
  const remaining = Math.max(0, max - current);
  const pct = remaining / max;
  const urgentColor = pct <= 0.2 ? '#FEE2E2' : pct <= 0.5 ? '#FEF3C7' : (textColor || '#fff');
  const urgentBg = pct <= 0.2 ? T.dangerBg : pct <= 0.5 ? T.warningBg : T.borderHover;
  return (
    <div style={{
      display: 'inline-flex', alignItems: 'center', gap: 4, marginTop: 10,
      padding: '4px 12px', borderRadius: 20, background: urgentBg,
      fontSize: 13, fontWeight: 700, color: urgentColor,
    }}>
      {remaining === 0 ? 'Esgotado!' : `Apenas ${remaining} vagas restantes!`}
    </div>
  );
}
